import { Injectable } from '@angular/core';
import { ActionPlanPlugin } from '../models/index';
import { BasePlugin } from './base-plugin.service';

import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { ApiService } from './api.service';
import { ActionPlanDataService } from './action-plan-data.service';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root'
})
export class ActionPlanPluginService extends BasePlugin {
  constructor(protected apiService: ApiService, protected service: ActionPlanDataService) {
    super();
  }

  public getPlugin(actionPlanId: string, pluginId: string): Observable<ActionPlanPlugin> {
    return this.service.getPlugin(actionPlanId, pluginId);
  }

  public deletePlugin(inspectionId: string, pointId: string, pluginId: string): any {}

  protected copyTranslationValues(keys, values, language: LanguageService) {
    keys.forEach((key) =>
      language.getValueByKey(key.label).subscribe((value) => {
        const keyValue = { ...key };
        keyValue.label = value;
        values.push(keyValue);
      })
    );
  }
}
